import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";

export default function About() {
  return (
    <>
      <Navbar />

      <section className="max-w-5xl mx-auto px-4 pt-32 max-sm:pt-24 pb-16 font-signika">
        {/* TITLE */}
        <div className="text-center mb-6">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Tentang <span className="text-primary">Hijafera</span>
          </h1>
          <p className="text-gray-500">Lebih dari sekedar fashion, kami menghadirkan gaya hidup.</p>
        </div>

        {/* CONTENT */}
        <div className="space-y-8 text-gray-700 leading-relaxed text-justify">
          <p>
            Hijafera adalah brand fashion yang hadir untuk memberikan pilihan pakaian yang tidak hanya nyaman digunakan, tetapi juga mampu merepresentasikan karakter dan gaya hidup modern. Kami percaya bahwa fashion bukan hanya sekedar
            pakaian yang dikenakan, tetapi juga merupakan bentuk ekspresi diri yang dapat meningkatkan rasa percaya diri setiap orang yang memakainya.
          </p>

          <p>
            Sejak awal berdiri, Hijafera memiliki visi untuk menghadirkan produk-produk fashion berkualitas dengan desain yang elegan, minimalis, dan tetap mengikuti perkembangan tren masa kini. Setiap produk yang kami buat dirancang dengan
            perhatian pada detail, mulai dari pemilihan bahan, proses produksi, hingga kualitas akhir yang sampai ke tangan pelanggan.
          </p>

          <p>
            Kami memahami bahwa setiap pelanggan memiliki kebutuhan dan gaya yang berbeda. Oleh karena itu, Hijafera menghadirkan berbagai pilihan produk yang dapat digunakan dalam berbagai kesempatan, baik untuk aktivitas sehari-hari,
            bekerja, bersantai, maupun menghadiri acara tertentu. Dengan kombinasi desain yang modern dan material yang nyaman, kami ingin memastikan bahwa setiap produk yang kami hadirkan mampu memberikan pengalaman terbaik bagi para
            pelanggan kami.
          </p>

          <p>
            Hijafera juga berkomitmen untuk terus berkembang dan berinovasi dalam menghadirkan koleksi-koleksi terbaru. Kami selalu memperhatikan feedback dari pelanggan agar dapat terus meningkatkan kualitas produk serta layanan yang kami
            berikan. Kepuasan pelanggan adalah prioritas utama kami, karena kami percaya bahwa hubungan yang baik dengan pelanggan adalah kunci utama dalam membangun brand yang kuat dan terpercaya.
          </p>

          <p>
            Selain fokus pada kualitas produk, Hijafera juga berupaya menghadirkan pengalaman berbelanja yang mudah, aman, dan menyenangkan melalui platform digital yang kami sediakan. Dengan sistem yang terus kami kembangkan, pelanggan
            dapat dengan mudah menemukan produk yang diinginkan, melihat detail produk secara lengkap, serta melakukan pemesanan dengan proses yang cepat dan praktis.
          </p>

          <p>
            Ke depan, Hijafera memiliki visi untuk menjadi salah satu brand fashion yang dikenal luas, tidak hanya di Indonesia tetapi juga di berbagai negara lainnya. Kami percaya bahwa dengan konsistensi dalam menjaga kualitas, inovasi
            dalam desain, serta pelayanan terbaik kepada pelanggan, Hijafera dapat terus tumbuh dan menjadi bagian dari perjalanan gaya hidup modern masyarakat.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
}
